import routes from './routes/routes';
import { createRouter, createWebHistory } from 'vue-router';

export const routerFactory = () => createRouter({
    history: createWebHistory(),
    routes,
});
